var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.85 18.3668H24.7V6.36682C24.7 3.56682 23.1834 3.00015 21.3334 5.10015L20 6.61682L8.71669 19.4502C7.16669 21.2002 7.81669 22.6335 10.15 22.6335H15.3V34.6335C15.3 37.4335 16.8167 38.0002 18.6667 35.9002L20 34.3835L31.2834 21.5502C32.8334 19.8002 32.1834 18.3668 29.85 18.3668Z",
    fill: "#207DF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlashIcon);
export default __webpack_public_path__ + "static/media/flashIcon.b8392e74c2e6b13f75b86f2b13861b62.svg";
export { ForwardRef as ReactComponent };